export const trimToNull = (str?: string): string | null => {
  if (!str) return null

  const trimmed = str.trim()
  return trimmed.length > 0 ? trimmed : null
}

